import { NavLink } from 'react-router-dom';
import React from 'react';
import { Home, LucideDock, Menu, Settings, User } from 'lucide-react';
interface SidebarProps{
  iscollapsed:boolean,
  setIsCollapsed:React.Dispatch<React.SetStateAction<boolean>>;
}
const Sidebar = ({iscollapsed,setIsCollapsed}:SidebarProps) => {
  const toggleSidebar=()=>{
    setIsCollapsed(prev=>!prev);
  }
  return (
    <aside className={`admin-sidebar p-3 ${iscollapsed ? 'collapsed' : ''}`}>
      <div className='d-flex justify-content-between g-0 align-items-center text-center'>
        {!iscollapsed && <h5 className="text-white">Menu</h5>}
        <button
          onClick={toggleSidebar} className='btn btn-sm btn-outline-light'>
          <Menu className='m-1 swing-icon'/>
        </button>
      </div>
      <ul className="nav flex-column mt-4">
        <li className="nav-item">
          <NavLink to="/admin" end className="nav-link text-white"> 
            <Home className='me-2 swing-icon'/>
           {!iscollapsed && 'Dashboard'}
           </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/admin/bordereau" end className="nav-link text-white"> 
            <LucideDock className='me-2 swing-icon'/>
           {!iscollapsed && 'Bordereaux'}
           </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/admin/users" className="nav-link text-white"> 
            <User className='me-2 swing-icon'/>
            {!iscollapsed && 'Utilisateurs'} 
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/admin/managers" className="nav-link text-white">
          <Settings className='me-2 swing-icon'/>
          {!iscollapsed && 'gestions'}
          </NavLink>
        </li>
        
      </ul>
    </aside>
  );
};

export default Sidebar;
